<template>
  <div
    class="flex items-center"
    :style="{width: `${height}px`, height: `${size}px`}"
  >
    <div
      class="logo bg-white flex items-center"
      style="border-radius: 10px"
      :class="{shadow}"
      :style="{width: `${height}px`}"
    >
      <img
        v-if="program.logo"
        class="object-center w-full"
        style="border-radius: 10px"
        :class="{shadow}"
        :src="`${program.logo.url}&h=${size}`"
        :alt="`${program.name}`"
      >
      <div
        v-else
        class="w-full flex justify-center align-center text-3xl font-semibold text-gray-600 rounded-full"
        :style="{borderRadius: `10px`, height: `${size}px`}"
      >
        P
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {Program, ProgramBundleProgram} from "@/program/interfaces/Program";
/**
 * Program logo component.
 */
export default defineComponent({
    name: 'ProgramLogo',
    props: {
    /**
     * The program to display the logo.
     */
        program: {
            type: Object as PropType<Program|ProgramBundleProgram>,
            required: true
        },
        size: {
            type: Number,
            default: 90
        },
        shadow: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        /**
         * The computed height of the logo.
         */
        height (): number {
            if (this.program.programmable_type === 'loyalty-card') {
                return this.size * 2;
            } else {
                return this.size;
            }
        }
    }
});
</script>
